'use client';
import { useWindowScroll } from '@s7/hooks';

/**
 * Хук для определения стиля тени в зависимости от положения полосы прокрутки.
 *
 * @returns SX - стиль с тенью / пустой объект
 */ const useShadowStyle = ()=>{
    const [scroll] = useWindowScroll();
    return scroll.y === 0 ? ({ shadows })=>({
            boxShadow: shadows.z100
        }) : {};
};

export { useShadowStyle };
//# sourceMappingURL=useShadowStyle.js.map
